import sbiLogo from '../Images/bosa-insurance-logo.png';
import wealthicon from '../Images/ESHN-logo.png'
import Broucher from './Broucher';
import MainTitle from './MainTitle';
import FormTest from './FormTest';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import Form from './Form';
import { IoIosMenu, IoMdAdd, IoMdClose } from "react-icons/io";
import { useEffect, useState } from 'react';
import Insuranceform from './Insuranceform';
import Test from './Test';
import './Navbar.css';
import axios from "axios";
import { useDispatch, useSelector } from 'react-redux';
import './Linkcontainer.css'

import test1 from '../Images/header-icon-1.svg'
import test2 from '../Images/header-icon-2.svg'
import test3 from '../Images/Connected world-cuate.svg'
import test4 from '../Images/widget_clicktocall.png'
import Linkcontainer from './Linkcontainer';
import {
  updateDOB,
  updateFirstName,
  updateLastName,
  updateGender,
  updateSmoke,
  updateMobileNo,
  updateEmail,
  updateSbgGroup,
  updateState,
  setDownloadPath,
  setCount,
  setPageCondition
} from '../formSlice';
import ThankYouPage from './ThankYouPage';
import Linkscontainer from './Linkcontainer';
import TestBoss from '../TestBoss';
function Navbar() {
  const [showform, setShowform] = useState(true);
  // const [page, setPage] = useState("2");
  const [isIdle, setIsIdle] = useState(false);
  const [lastActivity, setLastActivity] = useState(Date.now());
  const store = useSelector(state => state)
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useDispatch();
  const { uploadedpath, annualIncome, dob, firstName, lastName, gender, smoke, mobileNo, email, sbgGroup, state } = useSelector(state => state.form);
  const dummydata = {
    annual_income: annualIncome,
    date_of_birth: dob,
    first_name: firstName,
    last_name: lastName,
    gender: gender,
    smoker: smoke,
    mobile_number: mobileNo,
    email: email,
    spouse_employment: sbgGroup,
    state: state
  };

  const page = store.form.pageCondition


  const handleUserActivity = () => {
    setLastActivity(Date.now());
    setIsIdle(false);
  };

  useEffect(() => {
    const checkIdle = () => {
      if (Date.now() - lastActivity >= 15000) { // 15 seconds
        setIsIdle(true);
      }
    };

    const intervalId = setInterval(checkIdle, 15000);

    window.addEventListener('click', handleUserActivity);
    window.addEventListener('keydown', handleUserActivity);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('click', handleUserActivity);
      window.removeEventListener('keydown', handleUserActivity);
    };
  }, [lastActivity]);


  const handleClick = (e) => {
    e.preventDefault(); // Prevent the default anchor behavior
    window.location.href = 'https://jododemos.avhan.com/insurance/policy-list/';
  };

  function handletoggle() {
    setMenuOpen(!menuOpen);
  }

  function handleClose() {
    setMenuOpen(false);
  }


  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  }

  async function handlesubmit() {
    try {
      // const response = await axios.post('https://myjodo.jodoworld.com/bosaApi/bosa/pdf', dummydata);
      const response = await axios.post('https://jodostaging.avhan.com:4443/bosaApi/bosa/pdf', dummydata);
      console.log('Response:', response.data.uploadedpath);
      setSubmitted(true);
      dispatch(setDownloadPath(response.data.uploadedpath));
      // setPage("3")
      dispatch(setPageCondition('3'))
    } catch (error) {
      console.error('Error:', error);

    }

  }

//   useEffect(() => {
//     const script = document.createElement('script');
//     script.innerHTML = `
// var consoleValue = 1;
// var targetCallWs = "/CustomerWebServices/handleCustomerWS";
//   var apiKey = "EQt2eh25ufa6Jpmcc72B"
//   // var apiKey = "test_org"
// //  var serviceKey = "BosaVerification"
// var serviceKey = "gKh1RPbewz28EKjQ5n4c"
// var theme_parameter = "H";
//   // var serverPath = "https://myjodo.jodoworld.com"
// var serverPath="https://jodostaging.avhan.com:4443"
// var ajaxResponseTimeOut = 20000;
// var screenshareflag = 0;
// var errorMessage = false;

// var __acstoolbar = {};
// var jodoinitdone = false;
// __acstoolbar.servicekey = serviceKey;
// __acstoolbar.apikey = apiKey;
// __acstoolbar.tracelevel = "1";
// __acstoolbar.theme = "theme_blue2";
// __acstoolbar.serverpath = serverPath;
// __acstoolbar.applicationpath = serverPath;
// __acstoolbar.language = "english";
// __acstoolbar.target = serverPath;
// __acstoolbar.visible = "false";
// __acstoolbar.widgeticon = "show";
// __acstoolbar.csspath = "https://jodostaging.avhan.com:4443/widget_test/chatbotext_1.css";
// function addJqueryjs() {
// var script = document.createElement("script");
// script.src = serverPath + "/jodowidgetapi/js/jquery.min.js";
// document.body.appendChild(script);
// }

// (function () {
// var joinSC = document.createElement("script");
// joinSC.type = "text/javascript";
// joinSC.src = __acstoolbar.target + "/jodowidgetapi/js/initfunctions.js";

// joinSC.onload = validateKey;
// var joinScript = document.getElementsByTagName("script")[0];
// joinScript.parentNode.insertBefore(joinSC, joinScript);
// })();

// function validateKey() {
// var jodoInit = new jodoworld.initfunctions();
// jodoInit.initService();
// }

// function jodoCall() {
// var calldata = [];
// var calldataelement = {};
// var jodoInit = new jodoworld.initfunctions();
// if (jodoinitdone === true) {
// jodoInit.setLanguage('english');
// calldataelement = new Object();
// calldataelement.parameterid = 4011;
// calldataelement.value = 'english';
// calldata.push(calldataelement);
// jodoInit.SaveCustomerSessionData(calldata);
// jodoInit.showwidgetfromscript();
// jodoInit.showwidget_Voicefromscript();
// }
// }

// function jodoWidgetInitialized() {
// jodoinitdone = true;
// setTimeout(function () {
// jodoCall();
// }, 1000);
// }

// addJqueryjs();

// function waitForJodoInitDone() {
// if (jodoinitdone) {
// errorMessage = false;

// setTimeout(function () {
// waitForJodoInitDone();
// }, 1000);
// }
// }

// waitForJodoInitDone();
// `;
//     document.body.appendChild(script);

//   }, [store.form.callWidget])


  //   const handlewidgetclick = () => {
  //     dispatch(setCount(1))


  //     const script = document.createElement('script');
  //     script.innerHTML = `
  // var consoleValue = 1;
  // var targetCallWs = "/CustomerWebServices/handleCustomerWS";
  //   var apiKey = "EQt2eh25ufa6Jpmcc72B"
  //   // var apiKey = "test_org"
  // //  var serviceKey = "BosaVerification"
  // var serviceKey = "gKh1RPbewz28EKjQ5n4c"
  // var theme_parameter = "H";
  //   // var serverPath = "https://myjodo.jodoworld.com"
  // var serverPath="https://jodostaging.avhan.com:4443"
  // var ajaxResponseTimeOut = 20000;
  // var screenshareflag = 0;
  // var errorMessage = false;

  // var __acstoolbar = {};
  // var jodoinitdone = false;
  // __acstoolbar.servicekey = serviceKey;
  // __acstoolbar.apikey = apiKey;
  // __acstoolbar.tracelevel = "1";
  // __acstoolbar.theme = "theme_blue2";
  // __acstoolbar.serverpath = serverPath;
  // __acstoolbar.applicationpath = serverPath;
  // __acstoolbar.language = "english";
  // __acstoolbar.target = serverPath;
  // __acstoolbar.visible = "false";
  // __acstoolbar.widgeticon = "show";
  // __acstoolbar.csspath = "https://jodostaging.avhan.com:4443/widget_test/chatbotext_1.css";
  // function addJqueryjs() {
  // var script = document.createElement("script");
  // script.src = serverPath + "/jodowidgetapi/js/jquery.min.js";
  // document.body.appendChild(script);
  // }

  // (function () {
  // var joinSC = document.createElement("script");
  // joinSC.type = "text/javascript";
  // joinSC.src = __acstoolbar.target + "/jodowidgetapi/js/initfunctions.js";

  // joinSC.onload = validateKey;
  // var joinScript = document.getElementsByTagName("script")[0];
  // joinScript.parentNode.insertBefore(joinSC, joinScript);
  // })();

  // function validateKey() {
  // var jodoInit = new jodoworld.initfunctions();
  // jodoInit.initService();
  // }

  // function jodoCall() {
  // var calldata = [];
  // var calldataelement = {};
  // var jodoInit = new jodoworld.initfunctions();
  // if (jodoinitdone === true) {
  // jodoInit.setLanguage('english');
  // calldataelement = new Object();
  // calldataelement.parameterid = 4011;
  // calldataelement.value = 'english';
  // calldata.push(calldataelement);
  // jodoInit.SaveCustomerSessionData(calldata);
  // jodoInit.showwidgetfromscript();
  // jodoInit.showwidget_Voicefromscript();
  // }
  // }

  // function jodoWidgetInitialized() {
  // jodoinitdone = true;
  // setTimeout(function () {
  // jodoCall();
  // }, 1000);
  // }

  // addJqueryjs();

  // function waitForJodoInitDone() {
  // if (jodoinitdone) {
  // errorMessage = false;

  // setTimeout(function () {
  // waitForJodoInitDone();
  // }, 1000);
  // }
  // }

  // waitForJodoInitDone();
  // `;
  //     document.body.appendChild(script);

  //   }







  //production
  const handlewidgetclick = () => {
    dispatch(setCount(1))


    const script = document.createElement('script');
    script.innerHTML = `
  var consoleValue = 1;
  var targetCallWs = "/CustomerWebServices/handleCustomerWS";
    // var apiKey = "EQt2eh25ufa6Jpmcc72B"
  var apiKey = "test_org"
  var serviceKey = "BosaVerification"
  // var serviceKey = "gKh1RPbewz28EKjQ5n4c"
  var theme_parameter = "H";
  var serverPath = "https://myjodo.jodoworld.com"
  // var serverPath="https://jodostaging.avhan.com:4443"
  var ajaxResponseTimeOut = 20000;
  var screenshareflag = 0;
  var errorMessage = false;

  var __acstoolbar = {};
  var jodoinitdone = false;
  __acstoolbar.servicekey = serviceKey;
  __acstoolbar.apikey = apiKey;
  __acstoolbar.tracelevel = "1";
  __acstoolbar.theme = "theme_blue2";
  __acstoolbar.serverpath = serverPath;
  __acstoolbar.applicationpath = serverPath;
  __acstoolbar.language = "english";
  __acstoolbar.target = serverPath;
  __acstoolbar.visible = "false";
  __acstoolbar.widgeticon = "show";

  function addJqueryjs() {
  var script = document.createElement("script");
  script.src = serverPath + "/jodowidgetapi/js/jquery.min.js";
  document.body.appendChild(script);
  }

  (function () {
  var joinSC = document.createElement("script");
  joinSC.type = "text/javascript";
  joinSC.src = __acstoolbar.target + "/jodowidgetapi/js/initfunctions.js";

  joinSC.onload = validateKey;
  var joinScript = document.getElementsByTagName("script")[0];
  joinScript.parentNode.insertBefore(joinSC, joinScript);
  })();

  function validateKey() {
  var jodoInit = new jodoworld.initfunctions();
  jodoInit.initService();
  }

  function jodoCall() {
  var calldata = [];
  var calldataelement = {};
  var jodoInit = new jodoworld.initfunctions();
  if (jodoinitdone === true) {
  jodoInit.setLanguage('english');
  calldataelement = new Object();
  calldataelement.parameterid = 4011;
  calldataelement.value = 'english';
  calldata.push(calldataelement);
  jodoInit.SaveCustomerSessionData(calldata);
  jodoInit.showwidgetfromscript();
  jodoInit.showwidget_Voicefromscript();
  }
  }

  function jodoWidgetInitialized() {
  jodoinitdone = true;
  setTimeout(function () {
  jodoCall();
  }, 1000);
  }

  addJqueryjs();

  function waitForJodoInitDone() {
  if (jodoinitdone) {
  errorMessage = false;

  setTimeout(function () {
  waitForJodoInitDone();
  }, 1000);
  }
  }

  waitForJodoInitDone();
  `;
    document.body.appendChild(script);

  }


  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {

    if (store.form.callWidget === "true") {
      handlewidgetclick()
      console.log("dada2")
    }

  }, [store.form.callWidget]);


  return (
    <>
      <header>
        <div className="container header-container">
          <div className="d-flex align-items-center justify-content-between">
            <a href="../Images/bosa-insurance-logo.png" onClick={handleClick} >
              <div className="sbi-logo position-relative" title="Bosa Life Insurance">
                <img src={sbiLogo} alt="Bosa Logo" className="img-fluid" id="sbi-logo" />
              </div>
            </a>
            <a href="/" title="" id="title">
              <div className="wealth-logo">
              </div>
            </a>
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <button
              id="ctl00_ctl00_retrievequote"
              className="btn secondary-btn mr-lg-4 mr-3"
            >
              Retrieve Your Quote
            </button>

          </div>

        </div>
      </header>

      <div className={`main-container ${submitted ? 'thank-you-container' : ''}`}>
        <div className="left-side">
          <div className="containerd lato-bold">
            <div className="links">
              {isMobileView && (

                <button className='toggle-button' onClick={handletoggle}>
                  {menuOpen ? <IoMdClose /> : <IoIosMenu />}
                </button>
              )}
              {
                menuOpen && isMobileView ? (
                  <>
                    <div className='slider-page open'>
                      <div className="slider-header">
                        <button className="close-button" onClick={handleClose}>
                          <IoMdClose />
                        </button>
                      </div>
                      <a className="link lato-bold">
                        <img src={test1} className='image-1' alt="Benefit of Plan"></img>
                        <span>Benefit of Plan</span>
                        <div className='benefit-of-plan'>
                        </div>
                      </a>
                      <a className="link lato-bold">
                        <span>Why Us</span>
                        <div className='class-whyus'>
                          <img src={test2} className='image-2' alt="Why Us"></img>
                        </div>
                      </a>
                    </div>
                  </>
                ) : !isMobileView && (
                  <div style={{ left: "64px", bottom: "375px", position: "fixed" }}>
                    <a style={{ color: "#256EFF", }}>
                      <div className='benefit-of-plan' style={{ marginBottom: '15px' }}>
                        <img src={test1} className='image-1' alt="Benefit of Plan" />
                        <span>Benefit of Plan</span>
                      </div>
                    </a>
                    <a style={{ color: "#256EFF" }}>
                      <div className='class-whyus' >
                        <img src={test2} className='image-2' alt="Why Us" />
                        <span>Why Us</span>
                      </div>
                    </a>

                    {/* <a >
                      <div>
                        <img src={test1} className='image-1' alt="Benefit of Plan" />
                        <span>Benefit of Plan</span>
                      </div>
                    </a>
                    <a >
                      <div >
                        <img src={test2} className='image-2' alt="Why Us" />
                        <span>Why Us</span>
                      </div>
                    </a> */}
                  </div>
                )}


              {/* <div>
                <div onClick={handlewidgetclick} className="link need-help-link">
                  <div className='need-help-class'>
                    We're here to help! Click here for LIVE call with
                  </div>
                </div>
                <div className='widget-icon' onClick={handlewidgetclick}>
                  <img src={test4} className='image-3' alt="Widget Icon"></img>
                </div>
              </div> */}
              {store.form.count === 0 ? (
                <div>
                  <div
                   onClick={handlewidgetclick} 
                   className="link need-help-link">
                    <div className='need-help-class'>
                      Hi, I am Prachi, here to assist you with the form and policy details
                    </div>
                  </div>
                  <div className='widget-icon'
                   onClick={handlewidgetclick}
                   >
                    <img src={test4} className='image-3' alt="Widget Icon"></img>
                  </div>
                </div>
              ) : store.form.count === 1 ? (
                <div className="link need-help-link">
                  <div className='need-help-class'>
                    Hi, I am Prachi, here to assist you with the form and policy details
                  </div>
                </div>
              ) : null}

            </div>
          </div>
        </div>
        <div className="right-side" >
          {console.log(page, "page")}
          {page !== "3" && <Broucher></Broucher>}
          <div className="upper-part">
            {page !== "3" && <MainTitle></MainTitle>}
          </div>
          <div className='lower-section' >
            {page === "1" ?
              <TestBoss />
              :
              page === '2' ?
                <div>
                  <Insuranceform handlesubmit={handlesubmit}></Insuranceform>
                </div>
                : <ThankYouPage />


            }

          </div>



        </div>
      </div>
    </>
  )
}
export default Navbar;
